package info.rezident.app.ui.components.widgets

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import info.rezident.app.ui.theme.AppTheme
import org.jetbrains.compose.web.css.px

/**
 * Individual characteristic tag component
 */
@Composable
private fun CharacteristicTag(
    text: String,
    modifier: Modifier = Modifier
) {
    Box(
        modifier = modifier
            .backgroundColor(AppTheme.colors.section) // Using skyBlue60 from your palette
            .borderRadius(16.px)
            .padding(leftRight = 12.px, topBottom = 4.px)
            .flexShrink(0), // Prevent shrinking in flex container
        contentAlignment = Alignment.Center
    ) {
        SpanText(
            text = text,
            modifier = AppTheme.typography.body2.toModifier()
                .color(AppTheme.colors.text)
                .lineHeight(1.2)
                .whiteSpace(WhiteSpace.NoWrap) // Prevent text wrapping
        )
    }
}

/**
 * Scrollable horizontal list of characteristic tags
 */
@Composable
fun CharacteristicTags(
    characteristics: List<String>,
    modifier: Modifier = Modifier,
    maxVisibleTags: Int = Int.MAX_VALUE
) {
    if (characteristics.isNotEmpty()) {
        Row(
            modifier = modifier
                .fillMaxWidth()
                // Enable horizontal scrolling
                // Hide vertical overflow
                .overflow(overflowX = Overflow.Auto, overflowY = Overflow.Hidden),
            horizontalArrangement = Arrangement.spacedBy(6.px)
        ) {
            characteristics.take(maxVisibleTags).forEach { characteristic ->
                CharacteristicTag(text = characteristic)
            }
        }
    }
}
